import {jsx as _jsx} from "react/jsx-runtime";import { useEffect, useState} from 'react'
import {RelayEnvironmentProvider} from 'react-relay'
import Atmosphere from '../../Atmosphere'








const AtmosphereProvider = (props) => {
  const {children, getLocalAtmosphere} = props
  const [atmosphere, setAtmosphere] = useState(() => {
    if (!getLocalAtmosphere) {
      return new Atmosphere()
    }
    return undefined
  })

  useEffect(() => {
    if (!getLocalAtmosphere && atmosphere instanceof Atmosphere) {
      const cleanup = atmosphere.registerCookieListener(window)
      return cleanup
    }
    return undefined
  }, [atmosphere, getLocalAtmosphere])

  useEffect(() => {
    if (getLocalAtmosphere) {
      getLocalAtmosphere()
        .then((mod) => {
          setAtmosphere(new mod.default())
        })
        .catch(() => {
          /*ignore*/
        })
    }
  }, [getLocalAtmosphere])

  if (!atmosphere) return null
  return _jsx(RelayEnvironmentProvider, { environment: atmosphere, children: children})
}

export default AtmosphereProvider
